{
  "id": 1,
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
            "text": "Oh!Hunger",
            "headerStyling": {
              "textColor": "text_Highest_Emphasis",
              "textVariant": "header_H3_Black"
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
            "tabs": [
              {
                "id": "Order Online",
                "title": "Order Online"
              }
            ]
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "666909",
              "name": "Oh!Hunger",
              "city": "Delhi",
              "slugs": {
                "restaurant": "oh!hunger-karol-bagh-karol-bagh",
                "city": "delhi"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "d270f97263e5e0a99cb99137e4a58c8b",
              "locality": "Chuna Mandi",
              "areaName": "Paharganj",
              "costForTwo": "25000",
              "costForTwoMessage": "₹250 for two",
              "cuisines": ["Fast Food", "Snacks"],
              "avgRating": 4.2,
              "feeDetails": {
                "restaurantId": "666909",
                "fees": [{}]
              },
              "parentId": "400023",
              "avgRatingString": "4.2",
              "totalRatingsString": "2.9K+ ratings",
              "sla": {
                "restaurantId": "666909",
                "deliveryTime": 29,
                "minDeliveryTime": 25,
                "maxDeliveryTime": 30,
                "lastMileTravel": 2.1,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 96,
                "slaString": "25-30 MINS",
                "lastMileTravelString": "2.1 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2025-12-26 00:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {}
              },
              "aggregatedDiscountInfo": {
                "header": "Get every item @ 59",
                "shortDescriptionList": [
                  {
                    "meta": "Get every item @ 59",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off on orders above ₹199",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get every item @ 59",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off on orders above ₹199 | Use code FLAT100",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {},
              "slugString": "oh!hunger-karol-bagh-karol-bagh",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "1723, GF, Gali Pratap, Chuna Mandi, Paharganj New Delhi , KAROL BAGH, Central, Delhi-110055"
                },
                {
                  "title": "Cuisines",
                  "message": "Fast Food,Snacks"
                }
              ],
              "totalRatings": 2900,
              "aggregatedDiscountInfoV2": {
                "header": "Get every item @ 59",
                "shortDescriptionList": [
                  {
                    "meta": "Get every item @ 59",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off on orders above ₹199",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get every item @ 59",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off on orders above ₹199 | Use code FLAT100",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "priority": 9,
                  "discountInfo": {
                    "discountType": "FinalPrice",
                    "value": 109
                  },
                  "unlockedMessage": "Deal of the Day unlocked!",
                  "minItemCount": 1,
                  "maxItemCount": 1,
                  "type": "SILD",
                  "nudgeTagInfo": {
                    "title": "Deal of the Day",
                    "fontName": "FONT_NAME_CONDENSED_BOLD"
                  },
                  "logoCtx": {},
                  "movComputationType": "MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/666909"
              },
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {},
                "subTitle": {},
                "message": {},
                "customIcon": {},
                "commsStyling": {}
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {},
                "presentation": {}
              },
              "latLong": "28.641069,77.209671",
              "backgroundImageOverlayInfo": {},
              "featuredSectionInfo": {},
              "requestContexts": ["enable_ecosaver", "99store"]
            },
            "analytics": {}
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_AND_SHOW_MENU_OFFER_NUDGE",
            "sectionId": "MENU_ITEM_CART_UPDATE_POP_CROUTON"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {},
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "50% OFF",
                      "offerTag": "DEAL OF DAY",
                      "offerTagColor": "#E46D47",
                      "offerIds": ["3d3deff4-5f75-4cc2-b1d7-dca34271ee04"],
                      "expiryTime": "1970-01-01T00:56:06Z",
                      "offerType": "offers",
                      "restId": "666909",
                      "offerLogo": "offers/DealRush_Offer_Icon.png",
                      "descriptionTextColor": "#7302060C",
                      "showExpiryTimer": true,
                      "primaryDescription": "5 DEALS LEFT"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": ["f609cd84-fb53-43da-912e-ba9bccf494d7"],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLAT100",
                      "description": "ABOVE ₹199",
                      "offerType": "offers",
                      "restId": "666909",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE FLAT100"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹125 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": ["112e0e28-548a-474f-89cb-7cebbe4343fa"],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLAT125",
                      "description": "ABOVE ₹249",
                      "offerType": "offers",
                      "restId": "666909",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE FLAT125"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "50% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "offerIds": ["32bf37ac-aa33-4293-bed3-41a512ad2b25"],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE TRYNEW",
                      "description": "ABOVE ₹179",
                      "offerType": "offers",
                      "restId": "666909",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE TRYNEW"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹200 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": ["801c250e-4858-420a-a764-6a0802835b40"],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLAT200",
                      "description": "ABOVE ₹649",
                      "offerType": "offers",
                      "restId": "666909",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE FLAT200"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {}
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {}
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {},
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        "attributes": {
                          "displayText": "Ratings 4.0+"
                        }
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "99 Store",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129746211",
                              "name": "Potato & Vegetable Sandwich (brown Bread)",
                              "category": "Sandwiches",
                              "description": "Potato sandwich?s made with aloo tikki, vegetables & combination of sauces",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/30/29a17544-0e40-45ea-b0cf-10b94df2b25b_925269ce-dcdc-483b-96e3-4b67c094b23c.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 9900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "113 ratings",
                                  "ratingCountV2": "113"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep_widget",
                              "offerIds": [
                                "7201da4b-5963-4a8d-8ca4-d5ee6abdec2c"
                              ],
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "isNinetyninestoreItem": true,
                              "parentId": "75385694"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576930",
                              "name": "Tandoori Paneer Grilled Sandwich (brown Bread)",
                              "category": "Sandwiches",
                              "description": "Soft paneer marinated with curd and spices. Loaded with exotic vegetables.",
                              "imageId": "b5bb7ff584ad97aebc3a08fba8e29bed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20900,
                              "finalPrice": 10900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "308 ratings",
                                  "ratingCountV2": "308"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep_widget",
                              "offerIds": [
                                "fcc54975-da56-490d-8df7-cdf8a5843fdb"
                              ],
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "isNinetyninestoreItem": true,
                              "parentId": "62480122"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "subtitleColor": "highlight",
                      "categoryId": "1234567",
                      "widgetType": "WIDGET_TYPE_DISH_FIRST",
                      "categoryStyle": {
                        "layout": {
                          "rows": 1,
                          "columns": 2,
                          "itemSpacing": 16,
                          "containerStyle": {
                            "containerPadding": {
                              "left": 16,
                              "top": 8,
                              "right": 16,
                              "bottom": 12
                            }
                          }
                        },
                        "itemStyle": {
                          "width": {
                            "type": "TYPE_RELATIVE",
                            "value": 0.5,
                            "reference": "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                          },
                          "height": {
                            "type": "TYPE_RELATIVE",
                            "value": 0.9,
                            "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                          }
                        }
                      },
                      "headerStyle": {
                        "padding": {
                          "left": 16,
                          "top": 16,
                          "right": 16,
                          "bottom": 16
                        },
                        "titleColor": "text_color_highest_emphasis",
                        "titleFontName": "FONT_NAME_SUB_HEADER_S1_BOLD",
                        "imageStyle": {
                          "width": {},
                          "height": {}
                        },
                        "gradientStyle": {}
                      },
                      "dividerStyle": {
                        "color": "#1502060C",
                        "height": 1,
                        "padding": {
                          "left": 16,
                          "right": 16
                        }
                      },
                      "titleCreative": {
                        "creativeId": "affordable/Menu%20widget%20-%20Title%20badge%20-%203.png",
                        "style": {
                          "width": {
                            "type": "TYPE_ABSOLUTE",
                            "value": 84
                          },
                          "height": {
                            "type": "TYPE_ABSOLUTE",
                            "value": 25
                          }
                        }
                      },
                      "subtitleCreative": {
                        "creativeId": "99store/Category%20subtext.png?updatedAt=1756989067080",
                        "style": {
                          "width": {
                            "type": "TYPE_ABSOLUTE",
                            "value": 246
                          },
                          "height": {
                            "type": "TYPE_ABSOLUTE",
                            "value": 25
                          }
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576930",
                              "name": "Tandoori Paneer Grilled Sandwich (brown Bread)",
                              "category": "Sandwiches",
                              "description": "Soft paneer marinated with curd and spices. Loaded with exotic vegetables.",
                              "imageId": "b5bb7ff584ad97aebc3a08fba8e29bed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20900,
                              "finalPrice": 10900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "308 ratings",
                                  "ratingCountV2": "308"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "fcc54975-da56-490d-8df7-cdf8a5843fdb"
                              ],
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "isNinetyninestoreItem": true,
                              "parentId": "62480122"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832043",
                              "name": "Classic Maggi",
                              "category": "Maggi & Momos",
                              "description": "Classic maggi with added extra vegetables & Spices.",
                              "imageId": "285a763faec0781c1f8944f808821627",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "476 ratings",
                                  "ratingCountV2": "476"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "62480066"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831984",
                              "name": "Poha With Sev",
                              "category": "All Day Breakfast",
                              "description": "Traditional Indian Breakfast made with flattened rice, onions, peanuts and flavored with basic spices and herbs served with medium spicy sev.",
                              "imageId": "7a0ba771f71c9f995a4a83a00497b8e5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "169394261",
                                  "groupName": "Extra For Any",
                                  "choices": [
                                    {
                                      "id": "122678749",
                                      "name": "Nimbu Pani",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678729",
                                      "name": "Jaljeera",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678736",
                                      "name": "Raita",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678743",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "103 ratings",
                                  "ratingCountV2": "103"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "62480108"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129746211",
                              "name": "Potato & Vegetable Sandwich (brown Bread)",
                              "category": "Sandwiches",
                              "description": "Potato sandwich?s made with aloo tikki, vegetables & combination of sauces",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/30/29a17544-0e40-45ea-b0cf-10b94df2b25b_925269ce-dcdc-483b-96e3-4b67c094b23c.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 9900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "113 ratings",
                                  "ratingCountV2": "113"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "7201da4b-5963-4a8d-8ca4-d5ee6abdec2c"
                              ],
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "isNinetyninestoreItem": true,
                              "parentId": "75385694"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576922",
                              "name": "Chicken Tikka Grilled Sandwich (brown Bread)",
                              "category": "Sandwiches",
                              "description": "Made with layers of?tandoori chicken, Vegetables and a homemade spicy mayonnaise dressing.",
                              "imageId": "ed102873ace7fcd6f5b9784db1a30387",
                              "inStock": 1,
                              "price": 22900,
                              "finalPrice": 8900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "136 ratings",
                                  "ratingCountV2": "136"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "9caf6a85-3e4e-42da-ae21-f9705c6593d3"
                              ],
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "63848610",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576931",
                              "name": "Adarak Wali Chai (mini Flask Serves 2-3)",
                              "category": "Beverages",
                              "description": "Ginger tea or adrak wali chai is?a warming, spiced and fragrant Indian tea made with fresh ginger roots.",
                              "imageId": "90cea1cd1b6eff5cf637e34c7c218564",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "124 ratings",
                                  "ratingCountV2": "124"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "62480032"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831975",
                              "name": "Mumbai Street Style Pav Bhaji",
                              "category": "All Day Breakfast",
                              "description": "Mumbai street food made of a spicy mashed vegetable curry served topped with a dollop of butter along with soft dinner roll.",
                              "imageId": "c9950bf23deeb3f297046ff0e236e75f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 7900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "169394263",
                                  "groupName": "Extra Add Ons",
                                  "choices": [
                                    {
                                      "id": "122678746",
                                      "name": "Raita",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678738",
                                      "name": "Jaljeera",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678731",
                                      "name": "Bhaji",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678725",
                                      "name": "Nimbu Pani",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678750",
                                      "name": "Pav 2 Pcs",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678735",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 7900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "227 ratings",
                                  "ratingCountV2": "227"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "ddb29a66-004d-473d-a6fd-0e9b88a39632"
                              ],
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "62480098",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129746208",
                              "name": "Cheese & Corn Sandwich (brown Bread)",
                              "category": "Sandwiches",
                              "description": "Corn sandwich is a filled primarily with sweet corn & Cheese along with other spices.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/30/268f6aab-1a71-4044-bcff-4647a866ebf7_38270eec-4094-4f1d-a1a6-5a2b24be1d16.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 7900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "59 ratings",
                                  "ratingCountV2": "59"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "ddb29a66-004d-473d-a6fd-0e9b88a39632"
                              ],
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "75385692",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117716238",
                              "name": "Egg Roll",
                              "category": "Rolls",
                              "description": "Indian style egg rolled in a bread.",
                              "imageId": "40486f92274e4e01e18e94bbe59505f2",
                              "inStock": 1,
                              "price": 9900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "125599020",
                                  "groupName": "Addon Egg",
                                  "choices": [
                                    {
                                      "id": "107814090",
                                      "name": "1 Egg",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814091",
                                      "name": "2 Egg",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599022",
                                  "groupName": "Choice Of Filling",
                                  "choices": [
                                    {
                                      "id": "107814092",
                                      "name": "Soya Filling",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814093",
                                      "name": "Paneer Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814094",
                                      "name": "Chicken Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814095",
                                      "name": "Malai Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814096",
                                      "name": "Mutton Masala",
                                      "price": 12900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599025",
                                  "groupName": "Choice Of Drinks",
                                  "choices": [
                                    {
                                      "id": "107814097",
                                      "name": "Ice Tea",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599026",
                                  "groupName": "Choice Of Sweet",
                                  "choices": [
                                    {
                                      "id": "107814098",
                                      "name": "Gulab Jamun 1 Pc",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "182 ratings",
                                  "ratingCountV2": "182"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "65727901"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832046",
                              "name": "Egg Bhurji Maggi",
                              "category": "Maggi & Momos",
                              "description": "Made with Indian style scrambled egg.",
                              "imageId": "e44004aac4df3a9d5f4e483a22a59d33",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "45 ratings",
                                  "ratingCountV2": "45"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "62480071"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832044",
                              "name": "Peri Peri Maggi",
                              "category": "Maggi & Momos",
                              "description": "Made with extra dose of peri peri sauce.",
                              "imageId": "6575e3e347e27529cb84c0906d4b0a7c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "161 ratings",
                                  "ratingCountV2": "161"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "62480107"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832047",
                              "name": "Chicken Keema Maggi",
                              "category": "Maggi & Momos",
                              "description": "Made with Spicy Chicken keema.",
                              "imageId": "0779117a4136f19ef1e07aa57e05205b",
                              "inStock": 1,
                              "price": 18900,
                              "finalPrice": 7900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "57 ratings",
                                  "ratingCountV2": "57"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "ddb29a66-004d-473d-a6fd-0e9b88a39632"
                              ],
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "62480050",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113821110",
                              "name": "Penne Alfredo Pasta With Garlic Bread",
                              "category": "Continental",
                              "description": "The?Alfredo Pasta?is an Italian?pasta?dish made using fresh penne?pasta, vegetables combined with butter, cream and cheese.",
                              "imageId": "15f579ecdf022bf645f073b8a9283ac4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "124897968",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "107558175",
                                      "name": "3 Pcs Of Chicken Meatballs",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107558176",
                                      "name": "3 Pcs Of Mutton Meatballs",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "65541010"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113821108",
                              "name": "Spaghetti Alfredo Pasta With Garlic Bread",
                              "category": "Continental",
                              "description": "The?Alfredo Pasta?is an Italian?pasta?dish made using fresh Spaghetti?pasta, vegetables combined with butter, cream and cheese.",
                              "imageId": "203fb6f02f3cae0fa745f962c00a8c74",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "124897967",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "107558175",
                                      "name": "3 Pcs Of Chicken Meatballs",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107558176",
                                      "name": "3 Pcs Of Mutton Meatballs",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "44 ratings",
                                  "ratingCountV2": "44"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "65541012"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832045",
                              "name": "Cheese & Jalapeno Maggi",
                              "category": "Maggi & Momos",
                              "description": "Made with Cheese & Jalapeno.",
                              "imageId": "1b194491d06902dc12b533739256afd8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "40 ratings",
                                  "ratingCountV2": "40"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "62480044"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117716241",
                              "name": "Takatak Paneer Tikka Roll",
                              "category": "Rolls",
                              "description": "Made with tandoori paneer, onion, capsicum, cocktail of sauces & Indian spices.",
                              "imageId": "193ac982ad8ac0c9bbc20921686ffa01",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "finalPrice": 8900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "125599047",
                                  "groupName": "Addon Egg",
                                  "choices": [
                                    {
                                      "id": "107814090",
                                      "name": "1 Egg",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814091",
                                      "name": "2 Egg",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599048",
                                  "groupName": "Choice Of Filling",
                                  "choices": [
                                    {
                                      "id": "107814092",
                                      "name": "Soya Filling",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814093",
                                      "name": "Paneer Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814094",
                                      "name": "Chicken Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814095",
                                      "name": "Malai Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814096",
                                      "name": "Mutton Masala",
                                      "price": 12900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599049",
                                  "groupName": "Choice Of Drinks",
                                  "choices": [
                                    {
                                      "id": "107814097",
                                      "name": "Ice Tea",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599050",
                                  "groupName": "Choice Of Sweet",
                                  "choices": [
                                    {
                                      "id": "107814098",
                                      "name": "Gulab Jamun 1 Pc",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "40 ratings",
                                  "ratingCountV2": "40"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "9caf6a85-3e4e-42da-ae21-f9705c6593d3"
                              ],
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "67273352",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110617185",
                              "name": "Rajma & Rice",
                              "category": "Indian Meal",
                              "description": "Made with protein rich kidney beans. Served with rice.",
                              "imageId": "2d72335d0004cedb54725a02a530e6ef",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "29 ratings",
                                  "ratingCountV2": "29"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "63685388"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110876020",
                              "name": "Sabudana Khichdi",
                              "category": "All Day Breakfast",
                              "description": "Made with tapioca pearls, whole spices, roasted peanuts, potatoes and fresh curry leaves.",
                              "imageId": "a3e91009b0a3a84b28adaf15a5128967",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 7900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "169394260",
                                  "groupName": "Extra For Any",
                                  "choices": [
                                    {
                                      "id": "122678749",
                                      "name": "Nimbu Pani",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678729",
                                      "name": "Jaljeera",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678736",
                                      "name": "Raita",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678743",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "77 ratings",
                                  "ratingCountV2": "77"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "ddb29a66-004d-473d-a6fd-0e9b88a39632"
                              ],
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "63591707",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113821103",
                              "name": "Chicken Kurket [6 Pcs]",
                              "category": "Continental",
                              "description": "Chicken kurket?are deep fried, stuffed with minced chicken, Potato and spices coated in crispy breadcrumbs.",
                              "imageId": "9ee3be8226ddd34bf17d221d0952b298",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "72 ratings",
                                  "ratingCountV2": "72"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "65541007"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576928",
                              "name": "Shredded Chicken Cold Sandwich (brown Bread)",
                              "category": "Sandwiches",
                              "description": "Made with shredded chicken, mayo, vegetables, flavored with salt & paper.",
                              "imageId": "a5d546677bb738f7d33c88b4130424b4",
                              "inStock": 1,
                              "price": 23900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "showImage": true,
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.5,
                                "height": 0.9
                              },
                              "parentId": "62480117"
                            },
                            "restaurant": {
                              "info": {
                                "id": "666909",
                                "parentId": "400023",
                                "sla": {
                                  "serviceability": "NON_SERVICEABLE",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {},
                                "badges": {},
                                "aggregatedDiscountInfoV2": {},
                                "badgesV2": {},
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED",
                      "widgetType": "WIDGET_TYPE_DISH_FIRST",
                      "categoryStyle": {
                        "layout": {
                          "rows": 1,
                          "columns": 2,
                          "horizontalScrollEnabled": true,
                          "itemSpacing": 16,
                          "containerStyle": {
                            "containerPadding": {
                              "left": 16,
                              "top": 12,
                              "right": 16,
                              "bottom": 12
                            }
                          }
                        },
                        "itemStyle": {
                          "width": {
                            "type": "TYPE_RELATIVE",
                            "value": 0.5,
                            "reference": "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                          },
                          "height": {
                            "type": "TYPE_RELATIVE",
                            "value": 1,
                            "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                          }
                        },
                        "supportEvenItemsOnly": true
                      },
                      "headerStyle": {
                        "padding": {
                          "left": 16,
                          "top": 16,
                          "right": 16,
                          "bottom": 16
                        },
                        "titleColor": "text_color_highest_emphasis",
                        "titleFontName": "FONT_NAME_SUB_HEADER_S1_BOLD",
                        "imageStyle": {
                          "width": {},
                          "height": {}
                        },
                        "gradientStyle": {}
                      },
                      "dividerStyle": {
                        "color": "#1502060C",
                        "height": 1,
                        "padding": {
                          "left": 16,
                          "right": 16
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "All Day Breakfast",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831984",
                              "name": "Poha With Sev",
                              "category": "All Day Breakfast",
                              "description": "Traditional Indian Breakfast made with flattened rice, onions, peanuts and flavored with basic spices and herbs served with medium spicy sev.",
                              "imageId": "7a0ba771f71c9f995a4a83a00497b8e5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "169394261",
                                  "groupName": "Extra For Any",
                                  "choices": [
                                    {
                                      "id": "122678749",
                                      "name": "Nimbu Pani",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678729",
                                      "name": "Jaljeera",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678736",
                                      "name": "Raita",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678743",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "103 ratings",
                                  "ratingCountV2": "103"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480108"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831975",
                              "name": "Mumbai Street Style Pav Bhaji",
                              "category": "All Day Breakfast",
                              "description": "Mumbai street food made of a spicy mashed vegetable curry served topped with a dollop of butter along with soft dinner roll.",
                              "imageId": "c9950bf23deeb3f297046ff0e236e75f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 7900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "169394263",
                                  "groupName": "Extra Add Ons",
                                  "choices": [
                                    {
                                      "id": "122678746",
                                      "name": "Raita",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678738",
                                      "name": "Jaljeera",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678731",
                                      "name": "Bhaji",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678725",
                                      "name": "Nimbu Pani",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678750",
                                      "name": "Pav 2 Pcs",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678735",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 7900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "227 ratings",
                                  "ratingCountV2": "227"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "ddb29a66-004d-473d-a6fd-0e9b88a39632"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480098",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110876024",
                              "name": "Hot N Healthy Steamed Black Chana",
                              "category": "All Day Breakfast",
                              "description": "Super healthy Steamed chana garnished with indian herbs & spices.",
                              "imageId": "bbdea2b52905e1c5c2a4aec21547cbca",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "101 ratings",
                                  "ratingCountV2": "101"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480078"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831976",
                              "name": "Vada Pav (2 Pcs)",
                              "category": "All Day Breakfast",
                              "description": "Savory dinner roll stuffed with fried mashed and spiced potato fritters.",
                              "imageId": "be79240af2f5d877e381e7fd055b219a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "finalPrice": 3900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "169394265",
                                  "groupName": "Extra For Vada Pav",
                                  "choices": [
                                    {
                                      "id": "122678730",
                                      "name": "Jaljeera",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678742",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678748",
                                      "name": "Nembu Pani",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "254 ratings",
                                  "ratingCountV2": "254"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "e0dbebae-461e-4fc0-a7d0-8ba51f921c60"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480127",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832038",
                              "name": "Bun Maska",
                              "category": "All Day Breakfast",
                              "description": "Bun & Butter",
                              "imageId": "6ac88422b882ed756f48020cebd8e5a5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "190 ratings",
                                  "ratingCountV2": "190"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480042"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831977",
                              "name": "Egg Bhurji With Pav",
                              "category": "All Day Breakfast",
                              "description": "Indian style spiced scrambled egg served with dinner roll.",
                              "imageId": "20c333611bdc4969b1a37de4f30887f9",
                              "inStock": 1,
                              "price": 15900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "169394264",
                                  "groupName": "Extra For Bhurji Pav",
                                  "choices": [
                                    {
                                      "id": "122678723",
                                      "name": "Pav 2 Pcs",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678733",
                                      "name": "Raita",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678727",
                                      "name": "Jaljeera",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678753",
                                      "name": "Egg Bhurji",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678747",
                                      "name": "Nimbu Pani",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678740",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "53 ratings",
                                  "ratingCountV2": "53"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480072"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831979",
                              "name": "Idili Sambar",
                              "category": "All Day Breakfast",
                              "description": "Steamed spongy rice cake paired with a spicy and tangy",
                              "imageId": "cf72cb7bff86a1c532419cd20cb76709",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "169394266",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "122678721",
                                      "name": "Idli 2 Pcs",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678732",
                                      "name": "Extra Tomoto & Coconut Chutney",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678744",
                                      "name": "Nimbu Pani",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678739",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678726",
                                      "name": "Jaljeera",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678751",
                                      "name": "Extra Sambar",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "149 ratings",
                                  "ratingCountV2": "149"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480081"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831985",
                              "name": "Upma With Chutney",
                              "category": "All Day Breakfast",
                              "description": "Traditional south Indian breakfast dish made by simmering roasted rava in tempered & spiced boiling water served with coconut chutney",
                              "imageId": "6aabdefd1067624a6eeb49ce11195933",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "169394259",
                                  "groupName": "Extra For Any",
                                  "choices": [
                                    {
                                      "id": "122678749",
                                      "name": "Nimbu Pani",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678729",
                                      "name": "Jaljeera",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678736",
                                      "name": "Raita",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678743",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "60 ratings",
                                  "ratingCountV2": "60"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480126"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110876020",
                              "name": "Sabudana Khichdi",
                              "category": "All Day Breakfast",
                              "description": "Made with tapioca pearls, whole spices, roasted peanuts, potatoes and fresh curry leaves.",
                              "imageId": "a3e91009b0a3a84b28adaf15a5128967",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 7900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "169394260",
                                  "groupName": "Extra For Any",
                                  "choices": [
                                    {
                                      "id": "122678749",
                                      "name": "Nimbu Pani",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678729",
                                      "name": "Jaljeera",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678736",
                                      "name": "Raita",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678743",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "77 ratings",
                                  "ratingCountV2": "77"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "ddb29a66-004d-473d-a6fd-0e9b88a39632"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "63591707",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831989",
                              "name": "Hummus Falafel",
                              "category": "All Day Breakfast",
                              "description": "Falafels & Hummus are?a middle eastern food made from chickpeas, spices, and herbs.",
                              "imageId": "660ae199256911f27d40ca7541175a66",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "169394268",
                                  "groupName": "Esxtra For Hummus Falafel",
                                  "choices": [
                                    {
                                      "id": "122678722",
                                      "name": "Nimbu Pani",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678741",
                                      "name": "Extra Falafe",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678752",
                                      "name": "Jaljeera",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678720",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678728",
                                      "name": "Extra Hummus",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "39 ratings",
                                  "ratingCountV2": "39"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480079"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831986",
                              "name": "Bisi Belle Bath",
                              "category": "All Day Breakfast",
                              "description": "Bisi bele bath?is a flavorsome, spicy and slightly tangy meal made with lentils, rice, mixed vegetables and a super aromatic spice powder.",
                              "imageId": "0f89c68a7c8a9ecf89490ca22b2ef5e3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "169394267",
                                  "groupName": "Extra For Bisi Belle Bath",
                                  "choices": [
                                    {
                                      "id": "122678734",
                                      "name": "Jaljeera",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678745",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678724",
                                      "name": "Jaggery, Pickle & Papad Churi",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678737",
                                      "name": "Nimbu Pani",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480039"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832039",
                              "name": "Bun Omelet",
                              "category": "All Day Breakfast",
                              "description": "Egg?omelette, stuffed in?bun.",
                              "imageId": "7e5255da515a8a07a459b55e60a400d9",
                              "inStock": 1,
                              "price": 14900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "32 ratings",
                                  "ratingCountV2": "32"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480043"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831988",
                              "name": "Hot Cup Corn Snack",
                              "category": "All Day Breakfast",
                              "description": "Made with?boiled corns, butter, lemon juice and spices?like chaat masala, garam masala, and chili powder.",
                              "imageId": "dfc4b0ebe350e8411d59b78d4545cd76",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "76 ratings",
                                  "ratingCountV2": "76"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480077"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831980",
                              "name": "Sambar Vada",
                              "category": "All Day Breakfast",
                              "description": "Donut shaped lentil fritters?that are fluffy, crispy, soft and delicious paired with a spicy and tangy?sambar served with coconut & red chutney.",
                              "imageId": "026d87c4bb43727ea3b19411020f148b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "finalPrice": 3900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "169394262",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "122678721",
                                      "name": "Idli 2 Pcs",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678732",
                                      "name": "Extra Tomoto & Coconut Chutney",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678744",
                                      "name": "Nimbu Pani",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678739",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678726",
                                      "name": "Jaljeera",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "122678751",
                                      "name": "Extra Sambar",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "103 ratings",
                                  "ratingCountV2": "103"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "e0dbebae-461e-4fc0-a7d0-8ba51f921c60"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480116",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "7a0ba771f71c9f995a4a83a00497b8e5",
                      "categoryId": "32222325",
                      "widgetType": "WIDGET_TYPE_DISH_FIRST",
                      "categoryStyle": {
                        "layout": {}
                      },
                      "headerStyle": {
                        "padding": {
                          "left": 16,
                          "top": 16,
                          "right": 16,
                          "bottom": 16
                        },
                        "titleColor": "text_color_highest_emphasis",
                        "titleFontName": "FONT_NAME_SUB_HEADER_S1_BOLD",
                        "imageStyle": {
                          "width": {},
                          "height": {}
                        },
                        "gradientStyle": {}
                      },
                      "dividerStyle": {
                        "color": "#1502060C",
                        "height": 1,
                        "padding": {
                          "left": 16,
                          "right": 16
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sandwiches",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576930",
                              "name": "Tandoori Paneer Grilled Sandwich (brown Bread)",
                              "category": "Sandwiches",
                              "description": "Soft paneer marinated with curd and spices. Loaded with exotic vegetables.",
                              "imageId": "b5bb7ff584ad97aebc3a08fba8e29bed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20900,
                              "finalPrice": 10900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "308 ratings",
                                  "ratingCountV2": "308"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "fcc54975-da56-490d-8df7-cdf8a5843fdb"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "isNinetyninestoreItem": true,
                              "parentId": "62480122"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129746211",
                              "name": "Potato & Vegetable Sandwich (brown Bread)",
                              "category": "Sandwiches",
                              "description": "Potato sandwich?s made with aloo tikki, vegetables & combination of sauces",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/30/29a17544-0e40-45ea-b0cf-10b94df2b25b_925269ce-dcdc-483b-96e3-4b67c094b23c.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 9900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "113 ratings",
                                  "ratingCountV2": "113"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "7201da4b-5963-4a8d-8ca4-d5ee6abdec2c"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "isNinetyninestoreItem": true,
                              "parentId": "75385694"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576922",
                              "name": "Chicken Tikka Grilled Sandwich (brown Bread)",
                              "category": "Sandwiches",
                              "description": "Made with layers of?tandoori chicken, Vegetables and a homemade spicy mayonnaise dressing.",
                              "imageId": "ed102873ace7fcd6f5b9784db1a30387",
                              "inStock": 1,
                              "price": 22900,
                              "finalPrice": 8900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "136 ratings",
                                  "ratingCountV2": "136"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "9caf6a85-3e4e-42da-ae21-f9705c6593d3"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "63848610",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129746208",
                              "name": "Cheese & Corn Sandwich (brown Bread)",
                              "category": "Sandwiches",
                              "description": "Corn sandwich is a filled primarily with sweet corn & Cheese along with other spices.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/30/268f6aab-1a71-4044-bcff-4647a866ebf7_38270eec-4094-4f1d-a1a6-5a2b24be1d16.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 7900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "59 ratings",
                                  "ratingCountV2": "59"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "ddb29a66-004d-473d-a6fd-0e9b88a39632"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "75385692",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576928",
                              "name": "Shredded Chicken Cold Sandwich (brown Bread)",
                              "category": "Sandwiches",
                              "description": "Made with shredded chicken, mayo, vegetables, flavored with salt & paper.",
                              "imageId": "a5d546677bb738f7d33c88b4130424b4",
                              "inStock": 1,
                              "price": 23900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480117"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129746209",
                              "name": "Soya Tikka Sandwich (brown Bread)",
                              "category": "Sandwiches",
                              "description": "Soya sandwich made with soya chunk along with tangy tikka gravy.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/30/afbeb5f5-9b45-4110-8c55-300ac4501166_cb852a67-d930-44ef-b4dc-6bce4aa39723.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 7900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "ddb29a66-004d-473d-a6fd-0e9b88a39632"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "75385695",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129746210",
                              "name": "Mushroom & Corn Sandwich (brown Bread)",
                              "category": "Sandwiches",
                              "description": "Made with?ushroom & sweet?orn?long with tikka gravy.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/30/cf21e401-e64c-4bc3-be34-25e6e6e3b8ab_936df9ee-6481-40c3-81bf-64ee6832d6ab.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "finalPrice": 8900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "9caf6a85-3e4e-42da-ae21-f9705c6593d3"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "75385693",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "b5bb7ff584ad97aebc3a08fba8e29bed",
                      "categoryId": "32222331",
                      "widgetType": "WIDGET_TYPE_DISH_FIRST",
                      "categoryStyle": {
                        "layout": {}
                      },
                      "headerStyle": {
                        "padding": {
                          "left": 16,
                          "top": 16,
                          "right": 16,
                          "bottom": 16
                        },
                        "titleColor": "text_color_highest_emphasis",
                        "titleFontName": "FONT_NAME_SUB_HEADER_S1_BOLD",
                        "imageStyle": {
                          "width": {},
                          "height": {}
                        },
                        "gradientStyle": {}
                      },
                      "dividerStyle": {
                        "color": "#1502060C",
                        "height": 1,
                        "padding": {
                          "left": 16,
                          "right": 16
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Maggi & Momos",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832043",
                              "name": "Classic Maggi",
                              "category": "Maggi & Momos",
                              "description": "Classic maggi with added extra vegetables & Spices.",
                              "imageId": "285a763faec0781c1f8944f808821627",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "476 ratings",
                                  "ratingCountV2": "476"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480066"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832046",
                              "name": "Egg Bhurji Maggi",
                              "category": "Maggi & Momos",
                              "description": "Made with Indian style scrambled egg.",
                              "imageId": "e44004aac4df3a9d5f4e483a22a59d33",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "45 ratings",
                                  "ratingCountV2": "45"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480071"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832044",
                              "name": "Peri Peri Maggi",
                              "category": "Maggi & Momos",
                              "description": "Made with extra dose of peri peri sauce.",
                              "imageId": "6575e3e347e27529cb84c0906d4b0a7c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "161 ratings",
                                  "ratingCountV2": "161"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480107"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129106823",
                              "name": "Mutton Momos (6 Pcs)",
                              "category": "Maggi & Momos",
                              "description": "Made with ground mutton & vegetables, Served with eggless mayonnaise & spicy momos sauce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/15/817334af-b53e-4522-9b6c-2abfd7d17252_2c29a4bb-cc3c-45d5-909c-242e450ab65d.jpg",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.7",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#FFF0CD", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "74991087"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832047",
                              "name": "Chicken Keema Maggi",
                              "category": "Maggi & Momos",
                              "description": "Made with Spicy Chicken keema.",
                              "imageId": "0779117a4136f19ef1e07aa57e05205b",
                              "inStock": 1,
                              "price": 18900,
                              "finalPrice": 7900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "57 ratings",
                                  "ratingCountV2": "57"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "ddb29a66-004d-473d-a6fd-0e9b88a39632"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480050",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576915",
                              "name": "Chicken Momos Steam (6 Pcs)",
                              "category": "Maggi & Momos",
                              "description": "Made with chicken & other vegetables, Served with eggless mayonnaise & spicy momos sauce.",
                              "imageId": "1597c6b8c31da30d670e696b09eed5d3",
                              "inStock": 1,
                              "price": 18900,
                              "finalPrice": 7900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "ddb29a66-004d-473d-a6fd-0e9b88a39632"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62741852",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576918",
                              "name": "Paneer Momos Steam (6 Pcs)",
                              "category": "Maggi & Momos",
                              "description": "Made with Paneer & other vegetables, served with eggless mayonnaise & spicy momos sauce.",
                              "imageId": "789b986dafa18d9c554b0b98e0de03c0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "39 ratings",
                                  "ratingCountV2": "39"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62741862"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832045",
                              "name": "Cheese & Jalapeno Maggi",
                              "category": "Maggi & Momos",
                              "description": "Made with Cheese & Jalapeno.",
                              "imageId": "1b194491d06902dc12b533739256afd8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "40 ratings",
                                  "ratingCountV2": "40"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480044"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129106822",
                              "name": "Soya Momos (6 Pcs)",
                              "category": "Maggi & Momos",
                              "description": "Made with soya chunks & vegetables, Served with eggless mayonnaise & spicy momos sauce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/15/baa9bc1e-659e-4b71-b81f-5e1e9bf6e956_79a3f5dc-2c6d-4853-a8bc-bd9aa25fda07.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "74991088"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576921",
                              "name": "Veg Momos Steam (6 Pcs)",
                              "category": "Maggi & Momos",
                              "description": "Made with cabbage & other vegetables, served with eggless mayonnaise & spicy momos sauce.",
                              "imageId": "7ac268d2e4d9f2c9880ad4ce8f93ba16",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62741866"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "285a763faec0781c1f8944f808821627",
                      "categoryId": "43092088",
                      "widgetType": "WIDGET_TYPE_DISH_FIRST",
                      "categoryStyle": {
                        "layout": {}
                      },
                      "headerStyle": {
                        "padding": {
                          "left": 16,
                          "top": 16,
                          "right": 16,
                          "bottom": 16
                        },
                        "titleColor": "text_color_highest_emphasis",
                        "titleFontName": "FONT_NAME_SUB_HEADER_S1_BOLD",
                        "imageStyle": {
                          "width": {},
                          "height": {}
                        },
                        "gradientStyle": {}
                      },
                      "dividerStyle": {
                        "color": "#1502060C",
                        "height": 1,
                        "padding": {
                          "left": 16,
                          "right": 16
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Continental",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129964645",
                              "name": "Baked Mutton Meatballs (indian Style)",
                              "category": "Continental",
                              "description": "Baked Mutton meatballs made with ground mutton and a mixture of Indian spices, Served with Mint sauce",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "75543669"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113821108",
                              "name": "Spaghetti Alfredo Pasta With Garlic Bread",
                              "category": "Continental",
                              "description": "The?Alfredo Pasta?is an Italian?pasta?dish made using fresh Spaghetti?pasta, vegetables combined with butter, cream and cheese.",
                              "imageId": "203fb6f02f3cae0fa745f962c00a8c74",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "124897967",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "107558175",
                                      "name": "3 Pcs Of Chicken Meatballs",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107558176",
                                      "name": "3 Pcs Of Mutton Meatballs",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "44 ratings",
                                  "ratingCountV2": "44"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "65541012"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113821104",
                              "name": "Spaghetti Red Sauce Pasta With Garlic Bread",
                              "category": "Continental",
                              "description": "Red sauce spaghetti pasta is doused in?tomato sauce?and cooked in a seasoning of herbs parmesan cheese & spices.",
                              "imageId": "e3fb65783d48fef03717acbb11630408",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "124897965",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "107558175",
                                      "name": "3 Pcs Of Chicken Meatballs",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107558176",
                                      "name": "3 Pcs Of Mutton Meatballs",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.9",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#FFF0CD", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "65541013"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113821110",
                              "name": "Penne Alfredo Pasta With Garlic Bread",
                              "category": "Continental",
                              "description": "The?Alfredo Pasta?is an Italian?pasta?dish made using fresh penne?pasta, vegetables combined with butter, cream and cheese.",
                              "imageId": "15f579ecdf022bf645f073b8a9283ac4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "124897968",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "107558175",
                                      "name": "3 Pcs Of Chicken Meatballs",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107558176",
                                      "name": "3 Pcs Of Mutton Meatballs",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "65541010"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113821107",
                              "name": "Penne Red Sauce Pasta With Garlic Bread",
                              "category": "Continental",
                              "description": "Red sauce penne pasta is doused in?tomato sauce?and cooked in a seasoning of herbs parmesan cheese & spices.",
                              "imageId": "86467e130667db245fc9601a5b30c9d4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "124897966",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "107558175",
                                      "name": "3 Pcs Of Chicken Meatballs",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107558176",
                                      "name": "3 Pcs Of Mutton Meatballs",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.1",
                                  "ratingCount": "29 ratings",
                                  "ratingCountV2": "29"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "65541011"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118222515",
                              "name": "Baked Chicken Meatballs Indian Style (8 Pcs)",
                              "category": "Continental",
                              "description": "Baked Chicken meatballs made with ground chicken and a mixture of Indian spices, Served with Mint sauce.",
                              "imageId": "e52171e6b0a992cfadce8cddff627900",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "67797310"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113821103",
                              "name": "Chicken Kurket [6 Pcs]",
                              "category": "Continental",
                              "description": "Chicken kurket?are deep fried, stuffed with minced chicken, Potato and spices coated in crispy breadcrumbs.",
                              "imageId": "9ee3be8226ddd34bf17d221d0952b298",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "72 ratings",
                                  "ratingCountV2": "72"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "65541007"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113821106",
                              "name": "Jalapeno Cheese Balls [6 Pcs]",
                              "category": "Continental",
                              "description": "Jalapeno cheese balls?are deep fried, melted cheese balls stuffed with diced jalape?os and coated in crispy breadcrumbs.",
                              "imageId": "98800940915ef180861f47ee0d77522e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "65541009"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "203fb6f02f3cae0fa745f962c00a8c74",
                      "categoryId": "33505198",
                      "widgetType": "WIDGET_TYPE_DISH_FIRST",
                      "categoryStyle": {
                        "layout": {}
                      },
                      "headerStyle": {
                        "padding": {
                          "left": 16,
                          "top": 16,
                          "right": 16,
                          "bottom": 16
                        },
                        "titleColor": "text_color_highest_emphasis",
                        "titleFontName": "FONT_NAME_SUB_HEADER_S1_BOLD",
                        "imageStyle": {
                          "width": {},
                          "height": {}
                        },
                        "gradientStyle": {}
                      },
                      "dividerStyle": {
                        "color": "#1502060C",
                        "height": 1,
                        "padding": {
                          "left": 16,
                          "right": 16
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Indian Meal",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110617192",
                              "name": "Bihar Special Champaran Mutton & Rice",
                              "category": "Indian Meal",
                              "description": "Made with juicy mutton & mix of indian spices, Served with rice.",
                              "imageId": "58530a64fcb2663b9e37dbd2310abf42",
                              "inStock": 1,
                              "price": 35900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "63685377"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110617191",
                              "name": "Punjabi Chicken Curry & Rice",
                              "category": "Indian Meal",
                              "description": "Punjabi style cooked chicken, Served with rice",
                              "imageId": "64352b29e04bc4fa7c94860ddcc3c2df",
                              "inStock": 1,
                              "price": 30900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "63685387"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110617190",
                              "name": "Murg Makhani & Rice",
                              "category": "Indian Meal",
                              "description": "Indian curry made with a base of a spiced tomato & butter gravy. Served with rice.",
                              "imageId": "c20d8e0dc4364bc36555637a0d97814e",
                              "inStock": 1,
                              "price": 30900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "1.8",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#FFF0CD", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "63685383"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110617187",
                              "name": "Paneer Masala & Rice",
                              "category": "Indian Meal",
                              "description": "Paneer Masala?is a creamy gravy made with butter, tomatoes, and paneer. Served with rice.",
                              "imageId": "f600ee6d050f85fcbd0c0d07d3c23312",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "63685385"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110617188",
                              "name": "Dal Makhani & Rice",
                              "category": "Indian Meal",
                              "description": "Black lentils & red kidney beans are slow cooked with spices, butter & cream. Served with rice.",
                              "imageId": "289bb06017c12c8e60180a4754c45cdc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.9",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#FFF0CD", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "63685379"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110617185",
                              "name": "Rajma & Rice",
                              "category": "Indian Meal",
                              "description": "Made with protein rich kidney beans. Served with rice.",
                              "imageId": "2d72335d0004cedb54725a02a530e6ef",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "29 ratings",
                                  "ratingCountV2": "29"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "63685388"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110617186",
                              "name": "Yellow Dal Tadka Rice",
                              "category": "Indian Meal",
                              "description": "Yellow dal made with indian spices with a tempering made of ghee & served with rice.",
                              "imageId": "a76b030a9169f823df03838da39abf3f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "63685391"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "58530a64fcb2663b9e37dbd2310abf42",
                      "categoryId": "32222328",
                      "widgetType": "WIDGET_TYPE_DISH_FIRST",
                      "categoryStyle": {
                        "layout": {}
                      },
                      "headerStyle": {
                        "padding": {
                          "left": 16,
                          "top": 16,
                          "right": 16,
                          "bottom": 16
                        },
                        "titleColor": "text_color_highest_emphasis",
                        "titleFontName": "FONT_NAME_SUB_HEADER_S1_BOLD",
                        "imageStyle": {
                          "width": {},
                          "height": {}
                        },
                        "gradientStyle": {}
                      },
                      "dividerStyle": {
                        "color": "#1502060C",
                        "height": 1,
                        "padding": {
                          "left": 16,
                          "right": 16
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Beverages",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576931",
                              "name": "Adarak Wali Chai (mini Flask Serves 2-3)",
                              "category": "Beverages",
                              "description": "Ginger tea or adrak wali chai is?a warming, spiced and fragrant Indian tea made with fresh ginger roots.",
                              "imageId": "90cea1cd1b6eff5cf637e34c7c218564",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "124 ratings",
                                  "ratingCountV2": "124"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480032"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576935",
                              "name": "Masala Chai (mini Flask Serves 2-3)",
                              "category": "Beverages",
                              "description": "Made with a mix of Indian spices.",
                              "imageId": "26ced5b40fa5493a757e8afd44ad334f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "39 ratings",
                                  "ratingCountV2": "39"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480093"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576934",
                              "name": "Green Tea (mini Flask Serves 2-3)",
                              "category": "Beverages",
                              "description": "Made solely from the leaves of the camellia sinensis plan - Green tea has one of the highest concentrations of antioxidants of any tea",
                              "imageId": "3a964663226e31e492e7d4acb3ec5066",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {}
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480074"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576932",
                              "name": "Black Coffee (mini Flask Serves 2-3)",
                              "category": "Beverages",
                              "description": "Served without milk",
                              "imageId": "e7d37233c9656ed84b79b11e99c3b240",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480040"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576933",
                              "name": "Black Tea (mini Flask Serves 2-3)",
                              "category": "Beverages",
                              "description": "Served without milk.",
                              "imageId": "e4fbd4e28803655def2bb60b226e0f1f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480041"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115218226",
                              "name": "Lemon Iced Tea",
                              "category": "Beverages",
                              "description": "Made with black tea, lemon juice, sugar, water, and ice",
                              "imageId": "d9f99755e0312ac72bd520d040c04f6a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "66258506"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832066",
                              "name": "Nimbu Paani",
                              "category": "Beverages",
                              "description": "Indian style lemonade made with fresh lemon juice and sugar with a touch of spices.",
                              "imageId": "d73949d2f64ab41d3051959f89792354",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480099"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832067",
                              "name": "Jaljeera",
                              "category": "Beverages",
                              "description": "Jaljeera?is a tangy Indian beverage made using cilantro, mint, and spices.",
                              "imageId": "68f4547d4d56b0f23ceca45bc5eb96ef",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "34 ratings",
                                  "ratingCountV2": "34"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480083"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832062",
                              "name": "Masala Chach",
                              "category": "Beverages",
                              "description": "Refreshing buttermilk lightly spiced.",
                              "imageId": "df8643bf393190543318e4ae78c85b0d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480092"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "90cea1cd1b6eff5cf637e34c7c218564",
                      "categoryId": "32222333",
                      "widgetType": "WIDGET_TYPE_DISH_FIRST",
                      "categoryStyle": {
                        "layout": {}
                      },
                      "headerStyle": {
                        "padding": {
                          "left": 16,
                          "top": 16,
                          "right": 16,
                          "bottom": 16
                        },
                        "titleColor": "text_color_highest_emphasis",
                        "titleFontName": "FONT_NAME_SUB_HEADER_S1_BOLD",
                        "imageStyle": {
                          "width": {},
                          "height": {}
                        },
                        "gradientStyle": {}
                      },
                      "dividerStyle": {
                        "color": "#1502060C",
                        "height": 1,
                        "padding": {
                          "left": 16,
                          "right": 16
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Rolls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117716238",
                              "name": "Egg Roll",
                              "category": "Rolls",
                              "description": "Indian style egg rolled in a bread.",
                              "imageId": "40486f92274e4e01e18e94bbe59505f2",
                              "inStock": 1,
                              "price": 9900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "125599020",
                                  "groupName": "Addon Egg",
                                  "choices": [
                                    {
                                      "id": "107814090",
                                      "name": "1 Egg",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814091",
                                      "name": "2 Egg",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599022",
                                  "groupName": "Choice Of Filling",
                                  "choices": [
                                    {
                                      "id": "107814092",
                                      "name": "Soya Filling",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814093",
                                      "name": "Paneer Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814094",
                                      "name": "Chicken Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814095",
                                      "name": "Malai Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814096",
                                      "name": "Mutton Masala",
                                      "price": 12900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599025",
                                  "groupName": "Choice Of Drinks",
                                  "choices": [
                                    {
                                      "id": "107814097",
                                      "name": "Ice Tea",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599026",
                                  "groupName": "Choice Of Sweet",
                                  "choices": [
                                    {
                                      "id": "107814098",
                                      "name": "Gulab Jamun 1 Pc",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "182 ratings",
                                  "ratingCountV2": "182"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "65727901"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117716239",
                              "name": "Chatpata Chicken Tikka Roll",
                              "category": "Rolls",
                              "description": "Boneless chicken marinated in a blend of Indian spices and curd, grilled and served on a wrap.",
                              "imageId": "6fb2d58ae007624ac957f7667a8b0118",
                              "inStock": 1,
                              "price": 23900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "125599030",
                                  "groupName": "Addon Egg",
                                  "choices": [
                                    {
                                      "id": "107814090",
                                      "name": "1 Egg",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814091",
                                      "name": "2 Egg",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599032",
                                  "groupName": "Choice Of Filling",
                                  "choices": [
                                    {
                                      "id": "107814092",
                                      "name": "Soya Filling",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814093",
                                      "name": "Paneer Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814094",
                                      "name": "Chicken Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814095",
                                      "name": "Malai Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814096",
                                      "name": "Mutton Masala",
                                      "price": 12900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599033",
                                  "groupName": "Choice Of Drinks",
                                  "choices": [
                                    {
                                      "id": "107814097",
                                      "name": "Ice Tea",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599035",
                                  "groupName": "Choice Of Sweet",
                                  "choices": [
                                    {
                                      "id": "107814098",
                                      "name": "Gulab Jamun 1 Pc",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.1",
                                  "ratingCount": "46 ratings",
                                  "ratingCountV2": "46"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "67273347"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117716237",
                              "name": "Makhmali Malai Tikka Roll",
                              "category": "Rolls",
                              "description": "Chicken Malai Tikka Roll is made with tendered chicken tossed in onion, pepper and sauces.",
                              "imageId": "32c7351759aed181df5a580105185723",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "125599010",
                                  "groupName": "Addon Egg",
                                  "choices": [
                                    {
                                      "id": "107814090",
                                      "name": "1 Egg",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814091",
                                      "name": "2 Egg",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599012",
                                  "groupName": "Choice Of Filling",
                                  "choices": [
                                    {
                                      "id": "107814092",
                                      "name": "Soya Filling",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814093",
                                      "name": "Paneer Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814094",
                                      "name": "Chicken Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814095",
                                      "name": "Malai Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814096",
                                      "name": "Mutton Masala",
                                      "price": 12900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599014",
                                  "groupName": "Choice Of Drinks",
                                  "choices": [
                                    {
                                      "id": "107814097",
                                      "name": "Ice Tea",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599016",
                                  "groupName": "Choice Of Sweet",
                                  "choices": [
                                    {
                                      "id": "107814098",
                                      "name": "Gulab Jamun 1 Pc",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "67273349"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117716241",
                              "name": "Takatak Paneer Tikka Roll",
                              "category": "Rolls",
                              "description": "Made with tandoori paneer, onion, capsicum, cocktail of sauces & Indian spices.",
                              "imageId": "193ac982ad8ac0c9bbc20921686ffa01",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "finalPrice": 8900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "125599047",
                                  "groupName": "Addon Egg",
                                  "choices": [
                                    {
                                      "id": "107814090",
                                      "name": "1 Egg",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814091",
                                      "name": "2 Egg",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599048",
                                  "groupName": "Choice Of Filling",
                                  "choices": [
                                    {
                                      "id": "107814092",
                                      "name": "Soya Filling",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814093",
                                      "name": "Paneer Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814094",
                                      "name": "Chicken Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814095",
                                      "name": "Malai Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814096",
                                      "name": "Mutton Masala",
                                      "price": 12900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599049",
                                  "groupName": "Choice Of Drinks",
                                  "choices": [
                                    {
                                      "id": "107814097",
                                      "name": "Ice Tea",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599050",
                                  "groupName": "Choice Of Sweet",
                                  "choices": [
                                    {
                                      "id": "107814098",
                                      "name": "Gulab Jamun 1 Pc",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "40 ratings",
                                  "ratingCountV2": "40"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "9caf6a85-3e4e-42da-ae21-f9705c6593d3"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "67273352",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129712500",
                              "name": "Mushroom Tikka Roll",
                              "category": "Rolls",
                              "description": "Mushroom marinated & cooked with Tikka gravy",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/15/fce4e4ce-496f-4486-9b32-431119fb197b_af6e1683-f0bd-49df-b9aa-f3972c140593.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "75339031"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117716240",
                              "name": "Spicy Soya Roll",
                              "category": "Rolls",
                              "description": "Chatpata masaledar soya chap is cooked with crunchy onions & capsicums along with sauces and spices",
                              "imageId": "116a1be7d390cfc92340f365ecddc2f5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 7900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "125599039",
                                  "groupName": "Addon Egg",
                                  "choices": [
                                    {
                                      "id": "107814090",
                                      "name": "1 Egg",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814091",
                                      "name": "2 Egg",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599041",
                                  "groupName": "Choice Of Filling",
                                  "choices": [
                                    {
                                      "id": "107814092",
                                      "name": "Soya Filling",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814093",
                                      "name": "Paneer Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814094",
                                      "name": "Chicken Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814095",
                                      "name": "Malai Tikka",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107814096",
                                      "name": "Mutton Masala",
                                      "price": 12900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599043",
                                  "groupName": "Choice Of Drinks",
                                  "choices": [
                                    {
                                      "id": "107814097",
                                      "name": "Ice Tea",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125599046",
                                  "groupName": "Choice Of Sweet",
                                  "choices": [
                                    {
                                      "id": "107814098",
                                      "name": "Gulab Jamun 1 Pc",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "34 ratings",
                                  "ratingCountV2": "34"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "ddb29a66-004d-473d-a6fd-0e9b88a39632"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "67273351",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129712499",
                              "name": "Corn Tikka Roll",
                              "category": "Rolls",
                              "description": "Mushroom marinated & cooked with Tikka gravy",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/15/70b0b508-084c-4370-8cbd-cdc5f54ab9dc_4ceeffbb-ba0f-4703-b342-686c08130417.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "75339030"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "40486f92274e4e01e18e94bbe59505f2",
                      "categoryId": "35917596",
                      "widgetType": "WIDGET_TYPE_DISH_FIRST",
                      "categoryStyle": {
                        "layout": {}
                      },
                      "headerStyle": {
                        "padding": {
                          "left": 16,
                          "top": 16,
                          "right": 16,
                          "bottom": 16
                        },
                        "titleColor": "text_color_highest_emphasis",
                        "titleFontName": "FONT_NAME_SUB_HEADER_S1_BOLD",
                        "imageStyle": {
                          "width": {},
                          "height": {}
                        },
                        "gradientStyle": {}
                      },
                      "dividerStyle": {
                        "color": "#1502060C",
                        "height": 1,
                        "padding": {
                          "left": 16,
                          "right": 16
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Biryani",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832028",
                              "name": "Hydrabadi Mutton Biryani",
                              "category": "Biryani",
                              "description": "Hyderabadi mutton biryani?is a classic dish made by layering rice over slow cooked mutton gravy, served with raita.",
                              "imageId": "06f78747a4dc200867b3f2e63dae3258",
                              "inStock": 1,
                              "price": 39900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480080"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832029",
                              "name": "Lucknowi Chicken Biryani",
                              "category": "Biryani",
                              "description": "Awadhi chicken biryani (also known as?Lucknowi chicken biryani) made with long grain basmati rice, chicken, and mild spices, served with raita.",
                              "imageId": "f1655bcbe411daeb454363e71156e0a6",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480088"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832032",
                              "name": "Paneer Tikka Biryani",
                              "category": "Biryani",
                              "description": "Tandoori paneer biryani is a flavorful biryani, It is a vegetarian's delight cooked by marinating paneer with spices, served with raita.",
                              "imageId": "fc996d0fe0553e4e434f465dce54d166",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 34900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.9",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#FFF0CD", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480103"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832033",
                              "name": "Veg Biryani",
                              "category": "Biryani",
                              "description": "Vegetable biryani?is an aromatic rice dish made with basmati rice, spices & mixed veggies, served with raita.",
                              "imageId": "85fe8713d465212368a759fd82863d41",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "24998455"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "06f78747a4dc200867b3f2e63dae3258",
                      "categoryId": "32222327",
                      "widgetType": "WIDGET_TYPE_DISH_FIRST",
                      "categoryStyle": {
                        "layout": {}
                      },
                      "headerStyle": {
                        "padding": {
                          "left": 16,
                          "top": 16,
                          "right": 16,
                          "bottom": 16
                        },
                        "titleColor": "text_color_highest_emphasis",
                        "titleFontName": "FONT_NAME_SUB_HEADER_S1_BOLD",
                        "imageStyle": {
                          "width": {},
                          "height": {}
                        },
                        "gradientStyle": {}
                      },
                      "dividerStyle": {
                        "color": "#1502060C",
                        "height": 1,
                        "padding": {
                          "left": 16,
                          "right": 16
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Burger",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831990",
                              "name": "Tikki Burger",
                              "category": "Burger",
                              "description": "Crisp golden potato patties are sandwiched between burger buns and then topped with veggies & Sauce.",
                              "imageId": "c34689260ba758fa6729c73892cec78e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7900,
                              "finalPrice": 2900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "125119891",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "107652393",
                                      "name": "Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652394",
                                      "name": "Add Aloo Patty",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652395",
                                      "name": "Add Fries",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652396",
                                      "name": "Ice Tea",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652397",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "286 ratings",
                                  "ratingCountV2": "286"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "a927ada4-b889-4406-b5e9-0ab4d390cdac"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480125",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831995",
                              "name": "Chicken & Cheese Burger",
                              "category": "Burger",
                              "description": "Crispy?fried chicken?fillet, loaded with vegetables & Cheese.",
                              "imageId": "66602c7ebb7c295599d0cf412aa6dbf5",
                              "inStock": 1,
                              "price": 15900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "125119893",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "107652398",
                                      "name": "Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652399",
                                      "name": "Add Chicken Patty",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652400",
                                      "name": "Add Fries",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652401",
                                      "name": "Ice Tea",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652402",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480046"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831996",
                              "name": "Chicken Tikka Burger",
                              "category": "Burger",
                              "description": "Juicy and spicy pieces of chicken tikka, layered with fresh veggies and delicious sauces.",
                              "imageId": "d128d68ffbabd2bc5275af907aa9c7d9",
                              "inStock": 1,
                              "price": 16900,
                              "finalPrice": 6900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "125119892",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "107652398",
                                      "name": "Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652399",
                                      "name": "Add Chicken Patty",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652400",
                                      "name": "Add Fries",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652401",
                                      "name": "Ice Tea",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652402",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "568345f1-a79e-4493-bbc4-6f6099228ce8"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480056",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576911",
                              "name": "BBQ Chicken Burger",
                              "category": "Burger",
                              "description": "Crispy?fried chicken?fillet, loaded with vegatables & flavor of BBQ sauce.",
                              "imageId": "1062c924c7bc54924fabf06a93da3400",
                              "inStock": 1,
                              "price": 14900,
                              "finalPrice": 5900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "125119894",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "107652398",
                                      "name": "Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652399",
                                      "name": "Add Chicken Patty",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652400",
                                      "name": "Add Fries",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652401",
                                      "name": "Ice Tea",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652402",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "3d3deff4-5f75-4cc2-b1d7-dca34271ee04"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480037",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831992",
                              "name": "Paneer Tikki Burger",
                              "category": "Burger",
                              "description": "Made with juicy paneer patty along with fresh greens.",
                              "imageId": "c80eb19d908c65625740321b3dccf111",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "finalPrice": 4900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "125119896",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "107652403",
                                      "name": "Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652404",
                                      "name": "Add Paneer Patty",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652405",
                                      "name": "Add Fries",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652406",
                                      "name": "Ice Tea",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652407",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "45 ratings",
                                  "ratingCountV2": "45"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "3d684d37-7a44-4113-b6ca-806845f4afe2"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480106",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831993",
                              "name": "Juicy Chicken Burger",
                              "category": "Burger",
                              "description": "Crispy?fried chicken?fillet slathered with a special?burger?sauce & vegetables.",
                              "imageId": "d400e637c1c718fb4cba69622c1b0afc",
                              "inStock": 1,
                              "price": 13900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "125119895",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "107652398",
                                      "name": "Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652399",
                                      "name": "Add Chicken Patty",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652400",
                                      "name": "Add Fries",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652401",
                                      "name": "Ice Tea",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652402",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "42 ratings",
                                  "ratingCountV2": "42"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480084"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108831991",
                              "name": "Veggie Delight Burger",
                              "category": "Burger",
                              "description": "This larger than life veggie burger is?loaded with fresh greens and vegetable patty.",
                              "imageId": "04213b86ebfc9e25b26b2a109222a28b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8900,
                              "finalPrice": 3900,
                              "variants": {},
                              "variantsV2": {},
                              "addons": [
                                {
                                  "groupId": "125119897",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "107652408",
                                      "name": "Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652409",
                                      "name": "Add Veggie Patty",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652410",
                                      "name": "Add Fries",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652411",
                                      "name": "Ice Tea",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "107652412",
                                      "name": "Gulab Jamun 2 Pcs",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "122 ratings",
                                  "ratingCountV2": "122"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "e0dbebae-461e-4fc0-a7d0-8ba51f921c60"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480131",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "c34689260ba758fa6729c73892cec78e",
                      "categoryId": "32222326",
                      "widgetType": "WIDGET_TYPE_DISH_FIRST",
                      "categoryStyle": {
                        "layout": {}
                      },
                      "headerStyle": {
                        "padding": {
                          "left": 16,
                          "top": 16,
                          "right": 16,
                          "bottom": 16
                        },
                        "titleColor": "text_color_highest_emphasis",
                        "titleFontName": "FONT_NAME_SUB_HEADER_S1_BOLD",
                        "imageStyle": {
                          "width": {},
                          "height": {}
                        },
                        "gradientStyle": {}
                      },
                      "dividerStyle": {
                        "color": "#1502060C",
                        "height": 1,
                        "padding": {
                          "left": 16,
                          "right": 16
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Snacks",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129964646",
                              "name": "Chicken Cutlet 4 Pcs",
                              "category": "Snacks",
                              "description": "Made with boneless chicken & Indian spices, Served with mint sauce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/15/3a6030eb-ef1a-4292-8dfb-66a0d36e52c7_a2910980-0f80-47a1-b176-55bd2dd25b81.jpg",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "75543670"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832057",
                              "name": "Fries",
                              "category": "Snacks",
                              "description": "Classic salted fries.",
                              "imageId": "e97ee544cf54bf2a3bd215fd4f88cb73",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8900,
                              "finalPrice": 3900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "167 ratings",
                                  "ratingCountV2": "167"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "e0dbebae-461e-4fc0-a7d0-8ba51f921c60"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480073",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129964647",
                              "name": "Veg Cutlet 4 Pcs",
                              "category": "Snacks",
                              "description": "Made with mixed vegetables, herbs and spices, Served with mint sauce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/15/88f5db7f-62d9-4f55-bc28-da8dc40a306f_f21f8fb6-4b05-4d96-8c0b-4602ed829107.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "75543671"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108832058",
                              "name": "Mexican Salsa Fries",
                              "category": "Snacks",
                              "description": "Salted fries served with tangy aalsa sauce",
                              "imageId": "14c9261a694bf9d76324f9cf89894f0c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.3",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#FFF0CD", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "63333585"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131545818",
                              "name": "Potato Wedges",
                              "category": "Snacks",
                              "description": "Delicious golden-brown wedges are perfectly crispy on the outside and soft on the inside, Served with mint sauce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/15/56195c0b-bd91-49bf-bd05-cd1cb9456772_b4266453-503d-4484-b24c-1fe5dced067a.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "76540606"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/5/15/3a6030eb-ef1a-4292-8dfb-66a0d36e52c7_a2910980-0f80-47a1-b176-55bd2dd25b81.jpg",
                      "categoryId": "32222329",
                      "widgetType": "WIDGET_TYPE_DISH_FIRST",
                      "categoryStyle": {
                        "layout": {}
                      },
                      "headerStyle": {
                        "padding": {
                          "left": 16,
                          "top": 16,
                          "right": 16,
                          "bottom": 16
                        },
                        "titleColor": "text_color_highest_emphasis",
                        "titleFontName": "FONT_NAME_SUB_HEADER_S1_BOLD",
                        "imageStyle": {
                          "width": {},
                          "height": {}
                        },
                        "gradientStyle": {}
                      },
                      "dividerStyle": {
                        "color": "#1502060C",
                        "height": 1,
                        "padding": {
                          "left": 16,
                          "right": 16
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Fasting Meals",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126381353",
                              "name": "Sabutdana Vada",
                              "category": "Fasting Meals",
                              "description": "Made With Tapioca Pearls (Sago), Roasted Peanuts, Boiled Potatoes And Herbs Served Along With Raita",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/15/6841ae8a-c22b-4a3e-8a25-39c8e4e3f654_74905ce8-345f-4eb7-9ad0-e521b2ae17c3.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 7900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "ddb29a66-004d-473d-a6fd-0e9b88a39632"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "73124158",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126381360",
                              "name": "Sabudaba Khichdi",
                              "category": "Fasting Meals",
                              "description": "Sabudana Ki Khichdi Is A Delicious Dish Of Tapioca Pearls (Sago) Made With Potatoes & Peanuts Served Along With Raita",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/15/108d8a4b-55dd-4de2-a110-996a06233f0b_c45e0324-a4f6-4aa6-af88-ff18ac09e5a5.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 7900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {},
                              "badgesV2": {},
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "ddb29a66-004d-473d-a6fd-0e9b88a39632"
                              ],
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "73124157",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "10:00 AM"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126381349",
                              "name": "Aloo Chat",
                              "category": "Fasting Meals",
                              "description": "Crispy Potato Pieces Seasoned With Very Few Spices, Fresh Herbs And Drizzled Lemon Juice On Top.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/15/ec527d18-a2f8-4242-aa91-9409975a9d16_7ca1acb7-0c0b-406f-a5c2-f647ad205f04.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "73124154"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/5/15/6841ae8a-c22b-4a3e-8a25-39c8e4e3f654_74905ce8-345f-4eb7-9ad0-e521b2ae17c3.jpg",
                      "categoryId": "41334237",
                      "widgetType": "WIDGET_TYPE_DISH_FIRST",
                      "categoryStyle": {
                        "layout": {}
                      },
                      "headerStyle": {
                        "padding": {
                          "left": 16,
                          "top": 16,
                          "right": 16,
                          "bottom": 16
                        },
                        "titleColor": "text_color_highest_emphasis",
                        "titleFontName": "FONT_NAME_SUB_HEADER_S1_BOLD",
                        "imageStyle": {
                          "width": {},
                          "height": {}
                        },
                        "gradientStyle": {}
                      },
                      "dividerStyle": {
                        "color": "#1502060C",
                        "height": 1,
                        "padding": {
                          "left": 16,
                          "right": 16
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Dessert",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118074121",
                              "name": "Moong Dal Halwa",
                              "category": "Dessert",
                              "description": "Made moong, milk, sugar and nuts.",
                              "imageId": "7d4459f5940e478219f94c03cf02eb9a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "67576596"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113304427",
                              "name": "Kheer (cold) (150 Gm)",
                              "category": "Dessert",
                              "description": "A chilled south Asian dessert mate from rice milk, dry fruit & sugar",
                              "imageId": "7a3e64f9704406337c4a8395a1e77ebd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#C8F9E5", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "65286896"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111576936",
                              "name": "Gulab Jamun (2 Pcs)",
                              "category": "Dessert",
                              "description": "Fried dough balls that are soaked in a sweet, sticky sugar syrup",
                              "imageId": "d185664d5ef4e5fd8baa369382a1edd1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8900,
                              "variants": {},
                              "variantsV2": {},
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {},
                              "type": "ITEM",
                              "itemBadge": {},
                              "badgesV2": {},
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "29 ratings",
                                  "ratingCountV2": "29"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": ["#D9EFEC", "#00FFFFFF"],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "size": {
                                "width": 0.46,
                                "height": 1
                              },
                              "parentId": "62480075"
                            },
                            "analytics": {},
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {},
                      "image": "7d4459f5940e478219f94c03cf02eb9a",
                      "categoryId": "32222334",
                      "widgetType": "WIDGET_TYPE_DISH_FIRST",
                      "categoryStyle": {
                        "layout": {}
                      },
                      "headerStyle": {
                        "padding": {
                          "left": 16,
                          "top": 16,
                          "right": 16,
                          "bottom": 16
                        },
                        "titleColor": "text_color_highest_emphasis",
                        "titleFontName": "FONT_NAME_SUB_HEADER_S1_BOLD",
                        "imageStyle": {
                          "width": {},
                          "height": {}
                        },
                        "gradientStyle": {}
                      },
                      "dividerStyle": {
                        "color": "#1502060C",
                        "height": 1,
                        "padding": {
                          "left": 16,
                          "right": 16
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                      "header": {
                        "title": "Try these featured restaurants!",
                        "headerStyling": {
                          "padding": {
                            "left": 20,
                            "top": 24,
                            "bottom": 16
                          },
                          "titleSize": 18,
                          "subtitleSize": 14,
                          "titleColor": "#3e4152",
                          "titleFontName": "FONT_NAME_ALL_CAPS_AC1"
                        }
                      },
                      "layout": {
                        "rows": 1,
                        "columns": 6,
                        "horizontalScrollEnabled": true,
                        "widgetPadding": {},
                        "containerStyle": {
                          "containerPadding": {
                            "left": 8,
                            "right": 12,
                            "bottom": 16
                          }
                        },
                        "scrollBar": {
                          "scrollThumbColor": "#E46D47",
                          "scrollTrackColor": "#E4E4E4",
                          "width": 54,
                          "height": 4,
                          "scrollStyling": {
                            "padding": {
                              "top": 6,
                              "bottom": 24
                            }
                          }
                        },
                        "backgroundColor": "#F1F8FF",
                        "widgetBorderStyle": {
                          "top": {
                            "color": "#E7F4FD",
                            "height": 1
                          },
                          "bottom": {
                            "color": "#E7F4FD",
                            "height": 1
                          },
                          "left": {},
                          "right": {}
                        },
                        "widgetTheme": {
                          "defaultMode": {
                            "backgroundColour": "#F0F0F5",
                            "theme": "THEME_TYPE_LIGHT"
                          },
                          "darkMode": {
                            "backgroundColour": "#1B3028",
                            "theme": "THEME_TYPE_DARK"
                          }
                        }
                      },
                      "id": "adsOnlyMenuSimilarRestaurantWidgetUX4",
                      "gridElements": {
                        "infoWithStyle": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.SimilarRestaurantsInfoWithStyle",
                          "restaurants": [
                            {
                              "info": {
                                "id": "218676",
                                "name": "Chai Point",
                                "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/6/26/f3cb6247-bdad-4c38-9a4e-4f2cfdc503b9_218676.jpg",
                                "locality": "Connaught Place",
                                "areaName": "Connaught Place",
                                "costForTwo": "₹150 for two",
                                "cuisines": [
                                  "Bakery",
                                  "Beverages",
                                  "Maharashtrian",
                                  "Snacks",
                                  "Street Food",
                                  "South Indian",
                                  "Punjabi",
                                  "Chaat",
                                  "Indian",
                                  "American"
                                ],
                                "avgRating": 4.4,
                                "parentId": "1607",
                                "avgRatingString": "4.4",
                                "totalRatingsString": "8.3K+",
                                "adTrackingId": "cid=c2fa6272-c42a-4869-9dec-81334ef5a240~p=0~adgrpid=c2fa6272-c42a-4869-9dec-81334ef5a240#ag3~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=218676~plpr=HOME#SIMILAR_ENTITY~eid=381a043a-b857-4add-b3be-6c0e89474011~srvts=1766115234172~arid=666909",
                                "sla": {
                                  "deliveryTime": 24,
                                  "lastMileTravel": 1.6,
                                  "serviceability": "SERVICEABLE",
                                  "slaString": "20-25 mins",
                                  "lastMileTravelString": "1.6 km",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {
                                  "nextCloseTime": "2025-12-20 05:29:00",
                                  "opened": true
                                },
                                "badges": {},
                                "isOpen": true,
                                "badgesV2": {
                                  "entityBadges": {
                                    "textBased": {},
                                    "imageBased": {},
                                    "textExtendedBadges": {}
                                  }
                                },
                                "aggregatedDiscountInfoV3": {
                                  "header": "ITEMS",
                                  "subHeader": "AT ₹79",
                                  "logoCtx": {
                                    "text": "BENEFITS"
                                  }
                                },
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "externalRatings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "1.3K+"
                                  },
                                  "source": "GOOGLE",
                                  "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                },
                                "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                                "campaignId": "c2fa6272-c42a-4869-9dec-81334ef5a240"
                              },
                              "analytics": {
                                "screenName": "ux4-home-page",
                                "context": "{\"adTrackingId\":\"cid=c2fa6272-c42a-4869-9dec-81334ef5a240~p=0~adgrpid=c2fa6272-c42a-4869-9dec-81334ef5a240#ag3~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=218676~plpr=HOME#SIMILAR_ENTITY~eid=381a043a-b857-4add-b3be-6c0e89474011~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\",\"tid\":\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\"}",
                                "objectValue": "218676",
                                "impressionObjectName": "impression-similar-restaurant-item-ad",
                                "clickObjectName": "click-similar-restaurant-item-ad"
                              }
                            },
                            {
                              "info": {
                                "id": "697263",
                                "name": "Handi 47",
                                "cloudinaryImageId": "f60a0596a76581b140ea724a02b7805b",
                                "locality": "Lakshmi Narayan St",
                                "areaName": "Karol Bagh",
                                "costForTwo": "₹300 for two",
                                "cuisines": ["North Indian"],
                                "avgRating": 4.2,
                                "parentId": "417357",
                                "avgRatingString": "4.2",
                                "totalRatingsString": "791",
                                "adTrackingId": "cid=8646849f-b580-488f-bd7f-0a96829d32a0~p=1~adgrpid=8646849f-b580-488f-bd7f-0a96829d32a0#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=697263~plpr=HOME#SIMILAR_ENTITY~eid=2b6b355f-5b18-4cac-93ec-ca32374103d4~srvts=1766115234172~arid=666909",
                                "sla": {
                                  "deliveryTime": 32,
                                  "lastMileTravel": 2.8,
                                  "serviceability": "SERVICEABLE",
                                  "slaString": "30-40 mins",
                                  "lastMileTravelString": "2.8 km",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {
                                  "nextCloseTime": "2025-12-26 00:00:00",
                                  "opened": true
                                },
                                "badges": {},
                                "isOpen": true,
                                "badgesV2": {
                                  "entityBadges": {
                                    "imageBased": {},
                                    "textExtendedBadges": {},
                                    "textBased": {}
                                  }
                                },
                                "aggregatedDiscountInfoV3": {
                                  "header": "50% OFF",
                                  "logoCtx": {
                                    "text": "BENEFITS"
                                  },
                                  "footerText": "3 DEALS LEFT",
                                  "secondaryHeaderType": "SECONDARY_HEADER_TYPE_USAGE_LIMIT_OFFER"
                                },
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "externalRatings": {
                                  "aggregatedRating": {
                                    "rating": "--"
                                  }
                                },
                                "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                                "campaignId": "8646849f-b580-488f-bd7f-0a96829d32a0"
                              },
                              "analytics": {
                                "screenName": "ux4-home-page",
                                "context": "{\"adTrackingId\":\"cid=8646849f-b580-488f-bd7f-0a96829d32a0~p=1~adgrpid=8646849f-b580-488f-bd7f-0a96829d32a0#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=697263~plpr=HOME#SIMILAR_ENTITY~eid=2b6b355f-5b18-4cac-93ec-ca32374103d4~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\",\"tid\":\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\"}",
                                "objectValue": "697263",
                                "impressionObjectName": "impression-similar-restaurant-item-ad",
                                "clickObjectName": "click-similar-restaurant-item-ad"
                              }
                            },
                            {
                              "info": {
                                "id": "939876",
                                "name": "Chai Dilli",
                                "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/8/12/de90ab66-072f-4d03-98d8-d13c644a0650_939876.jpg",
                                "locality": "OLD RAJINDER NAGAR",
                                "areaName": "Karol Bagh",
                                "costForTwo": "₹200 for two",
                                "cuisines": [
                                  "Beverages",
                                  "Pizzas",
                                  "Pastas",
                                  "Fast Food",
                                  "Burgers"
                                ],
                                "avgRating": 4.3,
                                "veg": true,
                                "parentId": "551143",
                                "avgRatingString": "4.3",
                                "totalRatingsString": "183",
                                "adTrackingId": "cid=922a7ba2-ba8a-44dd-b8ba-9cbcc34ec1ac~p=2~adgrpid=922a7ba2-ba8a-44dd-b8ba-9cbcc34ec1ac#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=939876~plpr=HOME#SIMILAR_ENTITY~eid=bb2d9362-ed66-4dca-af1e-6ccd6435a7e3~srvts=1766115234172~arid=666909",
                                "sla": {
                                  "deliveryTime": 33,
                                  "lastMileTravel": 5,
                                  "serviceability": "SERVICEABLE",
                                  "slaString": "30-35 mins",
                                  "lastMileTravelString": "5.0 km",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {
                                  "nextCloseTime": "2025-12-19 23:59:00",
                                  "opened": true
                                },
                                "badges": {
                                  "imageBadges": [
                                    {
                                      "imageId": "v1695133679/badges/Pure_Veg111.png",
                                      "description": "pureveg"
                                    }
                                  ]
                                },
                                "isOpen": true,
                                "badgesV2": {
                                  "entityBadges": {
                                    "imageBased": {
                                      "badgeObject": [
                                        {
                                          "attributes": {
                                            "description": "pureveg",
                                            "imageId": "v1695133679/badges/Pure_Veg111.png"
                                          }
                                        }
                                      ]
                                    },
                                    "textExtendedBadges": {},
                                    "textBased": {}
                                  }
                                },
                                "aggregatedDiscountInfoV3": {
                                  "header": "ITEMS",
                                  "subHeader": "AT ₹19",
                                  "logoCtx": {
                                    "text": "BENEFITS"
                                  }
                                },
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "externalRatings": {
                                  "aggregatedRating": {
                                    "rating": "--"
                                  }
                                },
                                "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                                "campaignId": "922a7ba2-ba8a-44dd-b8ba-9cbcc34ec1ac"
                              },
                              "analytics": {
                                "screenName": "ux4-home-page",
                                "context": "{\"adTrackingId\":\"cid=922a7ba2-ba8a-44dd-b8ba-9cbcc34ec1ac~p=2~adgrpid=922a7ba2-ba8a-44dd-b8ba-9cbcc34ec1ac#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=939876~plpr=HOME#SIMILAR_ENTITY~eid=bb2d9362-ed66-4dca-af1e-6ccd6435a7e3~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\",\"tid\":\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\"}",
                                "objectValue": "939876",
                                "impressionObjectName": "impression-similar-restaurant-item-ad",
                                "clickObjectName": "click-similar-restaurant-item-ad"
                              }
                            },
                            {
                              "info": {
                                "id": "112346",
                                "name": "Aunty's Paranthe",
                                "cloudinaryImageId": "l8d63zn3czlht54ykil0",
                                "locality": "KAROL BAGH near bangal chicken corner",
                                "areaName": "Karol Bagh",
                                "costForTwo": "₹200 for two",
                                "cuisines": ["North Indian", "South Indian"],
                                "avgRating": 4.2,
                                "parentId": "15487",
                                "avgRatingString": "4.2",
                                "totalRatingsString": "9.8K+",
                                "adTrackingId": "cid=f770f9dd-7bce-4daa-b237-6f260d100516~p=3~adgrpid=f770f9dd-7bce-4daa-b237-6f260d100516#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=112346~plpr=HOME#SIMILAR_ENTITY~eid=0b52f14b-0401-48d0-8305-f50fb8e292de~srvts=1766115234172~arid=666909",
                                "sla": {
                                  "deliveryTime": 37,
                                  "lastMileTravel": 4.7,
                                  "serviceability": "SERVICEABLE",
                                  "slaString": "35-40 mins",
                                  "lastMileTravelString": "4.7 km",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {
                                  "nextCloseTime": "2025-12-19 15:00:00",
                                  "opened": true
                                },
                                "badges": {},
                                "isOpen": true,
                                "badgesV2": {
                                  "entityBadges": {
                                    "textBased": {},
                                    "imageBased": {},
                                    "textExtendedBadges": {}
                                  }
                                },
                                "aggregatedDiscountInfoV3": {
                                  "header": "50% OFF",
                                  "logoCtx": {
                                    "text": "BENEFITS"
                                  },
                                  "footerText": "3 DEALS LEFT",
                                  "secondaryHeaderType": "SECONDARY_HEADER_TYPE_USAGE_LIMIT_OFFER"
                                },
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "externalRatings": {
                                  "aggregatedRating": {
                                    "rating": "3.1",
                                    "ratingCount": "49"
                                  },
                                  "source": "GOOGLE",
                                  "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                },
                                "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                                "campaignId": "f770f9dd-7bce-4daa-b237-6f260d100516"
                              },
                              "analytics": {
                                "screenName": "ux4-home-page",
                                "context": "{\"adTrackingId\":\"cid=f770f9dd-7bce-4daa-b237-6f260d100516~p=3~adgrpid=f770f9dd-7bce-4daa-b237-6f260d100516#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=112346~plpr=HOME#SIMILAR_ENTITY~eid=0b52f14b-0401-48d0-8305-f50fb8e292de~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\",\"tid\":\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\"}",
                                "objectValue": "112346",
                                "impressionObjectName": "impression-similar-restaurant-item-ad",
                                "clickObjectName": "click-similar-restaurant-item-ad"
                              }
                            },
                            {
                              "info": {
                                "id": "1221537",
                                "name": "Boba Bhai - Bubble Tea & Korean Street Food",
                                "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/12/4/f156aec5-4281-45c6-be50-75861b8740d0_1221537.JPG",
                                "locality": "Patel Nagar",
                                "areaName": "East Patel Nagar",
                                "costForTwo": "₹200 for two",
                                "cuisines": [
                                  "Bubble Tea",
                                  "Burger",
                                  "Korean",
                                  "Beverages",
                                  "Fast Food",
                                  "Juice and shake"
                                ],
                                "avgRating": 4.6,
                                "parentId": "361235",
                                "avgRatingString": "4.6",
                                "totalRatingsString": "45",
                                "adTrackingId": "cid=7b0032b1-c921-4b20-be3d-5dfe53206357~p=4~adgrpid=7b0032b1-c921-4b20-be3d-5dfe53206357#ag4~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=1221537~plpr=HOME#SIMILAR_ENTITY~eid=73f493b1-14c3-4408-9eb8-dfcd963a8764~srvts=1766115234172~arid=666909",
                                "sla": {
                                  "deliveryTime": 41,
                                  "lastMileTravel": 6.8,
                                  "serviceability": "SERVICEABLE",
                                  "slaString": "40-45 mins",
                                  "lastMileTravelString": "6.8 km",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {
                                  "nextCloseTime": "2025-12-26 00:00:00",
                                  "opened": true
                                },
                                "badges": {},
                                "isOpen": true,
                                "badgesV2": {
                                  "entityBadges": {
                                    "imageBased": {},
                                    "textExtendedBadges": {},
                                    "textBased": {}
                                  }
                                },
                                "aggregatedDiscountInfoV3": {
                                  "header": "ITEMS",
                                  "subHeader": "AT ₹115",
                                  "logoCtx": {
                                    "text": "BENEFITS"
                                  }
                                },
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "isNewlyOnboarded": true,
                                "restaurantOfferPresentationInfo": {},
                                "externalRatings": {
                                  "aggregatedRating": {
                                    "rating": "--"
                                  }
                                },
                                "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                                "campaignId": "7b0032b1-c921-4b20-be3d-5dfe53206357"
                              },
                              "analytics": {
                                "screenName": "ux4-home-page",
                                "context": "{\"adTrackingId\":\"cid=7b0032b1-c921-4b20-be3d-5dfe53206357~p=4~adgrpid=7b0032b1-c921-4b20-be3d-5dfe53206357#ag4~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=1221537~plpr=HOME#SIMILAR_ENTITY~eid=73f493b1-14c3-4408-9eb8-dfcd963a8764~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\",\"tid\":\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\"}",
                                "objectValue": "1221537",
                                "impressionObjectName": "impression-similar-restaurant-item-ad",
                                "clickObjectName": "click-similar-restaurant-item-ad"
                              }
                            },
                            {
                              "info": {
                                "id": "375547",
                                "name": "Josie's Coffee House",
                                "cloudinaryImageId": "gx8s42xrhtgawdv5l0tp",
                                "locality": "Rajinder Nagar",
                                "areaName": "Karol Bagh",
                                "costForTwo": "₹300 for two",
                                "cuisines": ["Beverages", "Juices", "Desserts"],
                                "avgRating": 4.4,
                                "parentId": "111546",
                                "avgRatingString": "4.4",
                                "totalRatingsString": "981",
                                "adTrackingId": "cid=d3c58928-824e-4e06-b85c-7255714d0787~p=5~adgrpid=d3c58928-824e-4e06-b85c-7255714d0787#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=375547~plpr=HOME#SIMILAR_ENTITY~eid=17a2942e-8aa8-4647-ba54-67e6fcb53a5d~srvts=1766115234172~arid=666909",
                                "sla": {
                                  "deliveryTime": 39,
                                  "lastMileTravel": 5,
                                  "serviceability": "SERVICEABLE",
                                  "slaString": "35-40 mins",
                                  "lastMileTravelString": "5.0 km",
                                  "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {
                                  "nextCloseTime": "2025-12-20 00:30:00",
                                  "opened": true
                                },
                                "badges": {},
                                "isOpen": true,
                                "badgesV2": {
                                  "entityBadges": {
                                    "textBased": {},
                                    "imageBased": {},
                                    "textExtendedBadges": {}
                                  }
                                },
                                "aggregatedDiscountInfoV3": {
                                  "header": "50% OFF",
                                  "logoCtx": {
                                    "text": "BENEFITS"
                                  },
                                  "footerText": "3 DEALS LEFT",
                                  "secondaryHeaderType": "SECONDARY_HEADER_TYPE_USAGE_LIMIT_OFFER"
                                },
                                "differentiatedUi": {
                                  "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                  "differentiatedUiMediaDetails": {
                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE"
                                  }
                                },
                                "reviewsSummary": {},
                                "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                "restaurantOfferPresentationInfo": {},
                                "externalRatings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "686"
                                  },
                                  "source": "GOOGLE",
                                  "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                },
                                "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                                "campaignId": "d3c58928-824e-4e06-b85c-7255714d0787"
                              },
                              "analytics": {
                                "screenName": "ux4-home-page",
                                "context": "{\"adTrackingId\":\"cid=d3c58928-824e-4e06-b85c-7255714d0787~p=5~adgrpid=d3c58928-824e-4e06-b85c-7255714d0787#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=375547~plpr=HOME#SIMILAR_ENTITY~eid=17a2942e-8aa8-4647-ba54-67e6fcb53a5d~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\",\"tid\":\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\"}",
                                "objectValue": "375547",
                                "impressionObjectName": "impression-similar-restaurant-item-ad",
                                "clickObjectName": "click-similar-restaurant-item-ad"
                              }
                            }
                          ],
                          "widgetType": "WIDGET_TYPE_SRW",
                          "style": {}
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": ["License No. 13322005000901"]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Oh!Hunger",
                      "area": "Paharganj",
                      "completeAddress": "1723, GF, Gali Pratap, Chuna Mandi, Paharganj New Delhi , KAROL BAGH, Central, Delhi-110055"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "1dc8dfbd-09b9-4970-88af-f1bda78b7b47",
  "sid": "omwacd0d-0b54-4961-83b7-93696c74cc8c",
  "deviceId": "4ca02714-b64e-01a4-087c-5853e40864e6",
  "csrfToken": "ZGrrFfk8gIza-ncHx5TLi-Esw39hosN9I20Uon7E"
}
